var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiceS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 1.5H1.5V10.5H2.5H9.5H10.5V1.5H9.5H2.5ZM9.5 2.5V9.5H2.5V2.5H9.5ZM4.5 3.5H3.5V4.5H4.5V3.5ZM7.5 3.5H8.5V4.5H7.5V3.5ZM4.5 7.5H3.5V8.5H4.5V7.5ZM7.5 7.5H8.5V8.5H7.5V7.5ZM6.5 5.5H5.5V6.5H6.5V5.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiceS);
export default __webpack_public_path__ + "static/media/dice-s.a6377dbdd63af3b607d3159b42198082.svg";
export { ForwardRef as ReactComponent };